import { configureStore, Tuple } from '@reduxjs/toolkit';
import logger from 'redux-logger';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import reducers from './reducers';

// En local usa 158; en CI el deploy setea REACT_APP_PERSIST_VERSION (auto-incrementa).
export const VERSION = Number(process.env.REACT_APP_PERSIST_VERSION) || 158;

const persistConfig = {
  key: 'root',
  version: VERSION,
  storage,
  whitelist: ['auth', 'me'],
  migrate: (state: any) => {
    if (state && state._persist.version < VERSION) {
      console.log("Clean Persist State");
      return Promise.resolve({});
    }
    return Promise.resolve(state);
  },
};

const persistedReducer = persistReducer(persistConfig, reducers());

const store = configureStore({
  reducer: persistedReducer,
  // middleware: () => new Tuple(logger),
  devTools: process.env.REACT_APP_NODE_ENV !== 'production',
});
const persistor = persistStore(store);

export { store, persistor };
